/**
 * <Masthead volume="Vol. XI" subtitle="A beginner's tour" title="Photography" titleEm="· Canon EOS 6D Mk II" subline="..." byline="By ..." />
 */
export function Masthead({ volume, kicker, title, titleEm, subline, byline }) {
  return (
    <header className="border-t-0 border-b-[3px] border-double border-ink pt-12 pb-7 mb-12">
      <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent flex justify-between items-baseline pb-3 border-b border-rule mb-7">
        <span>{volume}</span>
        <span className="text-ink-muted">{kicker}</span>
      </div>
      <h1 className="h1-title m-0 mb-4">
        {title}
        {titleEm && (
          <>
            <br />
            <em>{titleEm}</em>
          </>
        )}
      </h1>
      {subline && (
        <p className="font-display italic font-light text-[1.3rem] text-ink-soft max-w-prose m-0 mb-5">
          {subline}
        </p>
      )}
      {byline && (
        <div className="font-mono text-[12px] text-ink-muted tracking-wider uppercase">
          {byline}
        </div>
      )}
    </header>
  );
}
